import { lazy, type ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { appRoutePaths, legacyRedirects, type AppRoutePath } from "@/lib/appRoutePaths";
import { localizedPath } from "@/locale/routes";
import type { AppLang } from "@/locale/appLang";
import Index from "@/pages/Index";
import OfferServicePage from "@/pages/services/OfferServicePage";

const CasesPage = lazy(() => import("@/pages/Cases"));
const AboutPage = lazy(() => import("@/pages/About"));
const ContactsPage = lazy(() => import("@/pages/ContactsPage"));
const DeleteData = lazy(() => import("@/pages/DeleteData"));
const Search = lazy(() => import("@/pages/Search"));

export type AppRouteDef = {
  path: string;
  element: ReactElement;
};

const routeElements: Record<AppRoutePath, ReactElement> = {
  "/": <Index />,
  "/services/incident": <OfferServicePage serviceId="incident" />,
  "/services/audit": <OfferServicePage serviceId="audit" />,
  "/services/retainer": <OfferServicePage serviceId="retainer" />,
  "/services/projects": <OfferServicePage serviceId="projects" />,
  "/cases": <CasesPage />,
  "/about": <AboutPage />,
  "/contacts": <ContactsPage />,
  "/delete-data": <DeleteData />,
  "/search": <Search />,
};

/** Активные маршруты витрины (все локали). */
export const appRoutes: AppRouteDef[] = appRoutePaths.map((path) => ({
  path,
  element: routeElements[path],
}));

/** Редиректы со старых URL (для каждой локали в App). */
export function legacyRedirectRoutes(lang: AppLang): AppRouteDef[] {
  return legacyRedirects.flatMap(({ from, to }) => {
    const target = localizedPath(to, lang);
    return [
      { path: from, element: <Navigate to={target} replace /> },
      // path without leading handling — App wraps with localizedPath
    ];
  });
}
